import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './EarlyAccessDomain.styles';
import {
  setEarlyAccessEmail,
  resetEarlyAccessError,
} from '../../../../store/actions/EarlyAccessActions';
import { AUTO_COMPLETE } from '../../../../constants/constants';
import { getCurrentOrg } from '../../../../store/selectors/CountryStateOrg';

export const VALID_EMAIL_PATTERN = [/^[^@]+@[^@]+\.[^@]+$/];

const EarlyAccessDomain = () => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const [emailValue, setEmailValue] = useState('');
  const showError =
    emailValue.length > 0 && !VALID_EMAIL_PATTERN[0].test(emailValue);
  const organization = useSelector(getCurrentOrg);
  const onEmailChange = useCallback(
    event => {
      const newEmail = event?.target?.value;
      setEmailValue(newEmail);
      dispatch(setEarlyAccessEmail(newEmail));
      if (VALID_EMAIL_PATTERN[0].test(newEmail)) {
        dispatch(resetEarlyAccessError());
      }
    },
    [dispatch],
  );

  if (!organization) {
    return null;
  }

  return (
    <FormattedMessage id="earlyAccess.domain.label">
      {emailLabel => (
        <TextField
          id="email"
          name="email"
          value={emailValue}
          onChange={onEmailChange}
          label={emailLabel}
          inputProps={{
            'data-testid': 'email',
            className: classes.input,
          }}
          error={showError}
          required
          autoComplete={AUTO_COMPLETE.EMAIL}
          helperText={<FormattedMessage id="earlyAccess.domain.helper" />}
        />
      )}
    </FormattedMessage>
  );
};

export default EarlyAccessDomain;
